import { render, staticRenderFns } from "./PurchaseEditExtraFields.vue?vue&type=template&id=e631b97e"
import script from "./PurchaseEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e631b97e')) {
      api.createRecord('e631b97e', component.options)
    } else {
      api.reload('e631b97e', component.options)
    }
    module.hot.accept("./PurchaseEditExtraFields.vue?vue&type=template&id=e631b97e", function () {
      api.rerender('e631b97e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditExtraFields.vue"
export default component.exports